import React, { useEffect, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'dva';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {
  CascadeFieldCom,
  SelectFieldCom,
  DatePickerCom,
  TextFieldCom,
} from '../../../components/FormType';
import webStorage from '@/utils/storageManager';

const getDicList = (value, dicObj) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const type = value[value.length - 1].conditionOneGroupType;

    return dicObj[type];
  }
  return [];
};
const getDicListTwo = (value, dicObj) => {
  if (value === 3) {
    return dicObj.PROFILE_ABSOLUTE_DATE_OPERATOR;
  } else if (value === 4) {
    return dicObj.PROFILE_RELATIVE_DATE_OPERATOR;
  }
  return [];
};

// eslint-disable-next-line no-unused-vars
const checkTypeStatus = (value) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1];
    return v;
  }
  return false;
};
// eslint-disable-next-line no-unused-vars
const checkTypeStatusTwo = (value) => {
  //判断是否是时间类型，
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].conditionTwoGroupType;
    return v ? v.split(',') : null;
  }
  return false;
};

// eslint-disable-next-line no-unused-vars
const checkTypeStatusThree = (value) => {
  //判断非时间是否是选择框
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].fileCodeEnumGroupType;
    return v;
  }
  return null;
};

const checkForm = (data, errors) => {
  let status = false;
  data.forEach((item) => {
    if (item.withinItem) {
      item.withinItem.forEach((it) => {
        for (let i in it) {
          if (errors && i !== 'remark' && errors[`${i}-${it.id}`]) {
            status = true;
            break;
          }
        }
      });
    }
  });
  return status;
};

//获取接口返回的选择项
const getFetchList = (value, data) => {
  let list = [];
  if (value && Array.isArray(value) && value.length > 0 && data) {
    const type = value[value.length - 1].fileCodeEnumGroupType;
    data.forEach((item) => {
      if (item.labelGroup === type) {
        list = item.valueAndLabelList;
        return;
      }
    });
  }
  return list;
};

const ISHAVEAVALUE = 1; //有值
const NOHAVEAVALUE = 2; //无值
const ISRELATIVE = 3; //绝对
const ISABSOLUTE = 4; //相对
const ISBEFORE = 3; //之前
const ISAFTER = 4; //之后

export default ({
  ruleList = null,
  tagCollectionInfo = null,
  queryType,
  setValue,
  getValues,
  control,
  errors,
  setError,
  clearErrors,
  cLabel,
  pid,
  handleAddRuleData,
  handleAddRuleDataDelete,
  handleAddRuleDetailData,
  handleAddRuleDetailDataDelete,
  setFieldValueP,
  detailId,
  ruleLabelDirectoryList,
  showButton,
}) => {
  const { queryTagOperatorValue } = useSelector(
    (state) => state.statisticsCreateLabel,
  );
  const PROFILE_COLLECT_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_COLLECT_OPERATOR; //集合类操作
  const PROFILE_TEXT_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_TEXT_OPERATOR; //文本类操作
  const PROFILE_NUMERICAL_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_NUMERICAL_OPERATOR; //数值类操作
  const PROFILE_DATE_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_DATE_OPERATOR; //日期类操作
  const PROFILE_ABSOLUTE_DATE_OPERATOR =
    webStorage
      .get('DICTOBJ')
      ?.PROFILE_ABSOLUTE_DATE_OPERATOR?.filter(
        (item) => item.dictValue !== 7 && item.dictValue !== 8,
      ) || []; //绝对日期操作
  const PROFILE_RELATIVE_DATE_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_RELATIVE_DATE_OPERATOR; // 相对日期操作
  const PROFILE_RELATIVE_DATE_RANGE_OPERATOR =
    webStorage.get('DICTOBJ')?.PROFILE_RELATIVE_DATE_RANGE_OPERATOR; //相对日期范围操作
  const dicObj = {
    PROFILE_COLLECT_OPERATOR,
    PROFILE_TEXT_OPERATOR,
    PROFILE_NUMERICAL_OPERATOR,
    PROFILE_DATE_OPERATOR,
    PROFILE_ABSOLUTE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_RANGE_OPERATOR,
  };
  const [number, setNumber] = useState(0);
  useEffect(() => {
    ruleList.forEach((item) => {
      if (item.withinItem) {
        item.withinItem.forEach((it) => {
          setValue(`valueFieldIds-${it.id}`, it.valueFieldIds);
          setValue(`operation-${it.id}`, it.operation);
          setValue(`operationValue-${it.id}`, it.operationValue);
          setValue(`operationAnd-${it.id}`, it.operationAnd);
          setValue(`operationAndValue-${it.id}`, it.operationAndValue);
          setValue(`operationType-${it.id}`, it.operationType);
        });
      }
    });
  }, [ruleList, setValue, tagCollectionInfo, number]);

  const setFieldValue = (data) => {
    const { self, value } = data; //self =1 点击的第一个级联，self = 2点击的非时间的选择和时间的第二个条件选择，self=3点击的时间的第一个条件
    setFieldValueP(data);

    const today = new Date();
    const date =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();
    if (self === 1) {
      //重置后面所有的值
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationType',
      });
    } else if (self === 2) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 3) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: value === 3 ? date : '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 4) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    }
    setNumber(number + 1);
  };

  return (
    <Box>
      <Box>
        <Box
          sx={{
            fontSize: '14px',
            color: '#212121',
            fontWeight: '400',
            lineHeight: '20px',
            marginBottom: '8px',
          }}
        >
          {cLabel}{' '}
          <span style={{ color: '#f44336', fontSize: '.75rem' }}>
            {checkForm(ruleList, errors) && '此项有未完成输入或选择项'}
          </span>
        </Box>
        <Box display="flex">
          <Box display="flex" gap="0 4px">
            <Box
              sx={{
                fontSize: '14px',
                color: '#212121',
                fontWeight: '400',
                lineHeight: '20px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              或
            </Box>
            <Box sx={{ width: '4px', background: '#1565C0' }}></Box>
          </Box>
          <Box flex="1">
            {ruleList.map((item, index) => {
              return (
                <Box key={index} pl={5} width="100%" mb={1}>
                  <Box display="flex" mb={1}>
                    <Box display="flex" gap="0 4px" mr={1}>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#4CAF50',
                          fontWeight: '400',
                          lineHeight: '20px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        且
                      </Box>
                      <Box sx={{ width: '4px', background: '#4CAF50' }}></Box>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      width="100%"
                    >
                      <Box
                        sx={{
                          border: '1px solid #CCCCCC',
                          borderRadius: '12px',
                          padding: '0 50px 19px 32px',
                          position: 'relative',
                          flex: 1,
                        }}
                      >
                        {item.withinItem.map((it, ind) => {
                          const textIsMultiline =
                            it.valueFieldIds?.[it.valueFieldIds.length - 1]
                              ?.type === 2;
                          const selectIsMultiple =
                            it.valueFieldIds?.[it.valueFieldIds.length - 1]
                              ?.type === 1;
                          return (
                            <Box
                              key={ind}
                              sx={{
                                display: 'flex',
                                gap: '0 16px',
                                alignItems: 'flex-end',
                              }}
                            >
                              <CascadeFieldCom
                                width={300}
                                label="请选择标签"
                                showLabel={false} //是否需要显示label
                                showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                cascadeData={ruleLabelDirectoryList}
                                queryType={queryType}
                                setValue={setValue}
                                control={control}
                                name={'valueFieldIds-' + it.id}
                                realName="valueFieldIds"
                                fieldNames={{ label: 'fileName', value: 'id' }}
                                nameMessage="标签目录必选项"
                                errors={errors}
                                setError={setError}
                                clearErrors={clearErrors}
                                setFieldValue={setFieldValue}
                                isShowSearch={true} //开启搜索
                                parameter={{
                                  wid: item.id,
                                  pid,
                                  type: cLabel === '满足',
                                  selfId: it.id,
                                  self: 1,
                                }}
                                rules={{
                                  validate: () => {
                                    if (
                                      !it.valueFieldIds ||
                                      (Array.isArray(it.valueFieldIds) &&
                                        it.valueFieldIds.length === 0)
                                    ) {
                                      return false;
                                    }
                                    return true;
                                  },
                                }}
                              />
                              {checkTypeStatus(it.valueFieldIds) &&
                                !checkTypeStatusTwo(it.valueFieldIds) && (
                                  <Box
                                    width="109px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <SelectFieldCom
                                      label="条件"
                                      placeholder="请选择"
                                      initLabel=""
                                      name={'operation-' + it.id}
                                      realName="operation"
                                      queryType={queryType}
                                      setValue={setValue}
                                      getValues={getValues}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      // defaultValue={it?.operation}
                                      nameMessage=""
                                      typeList={getDicList(
                                        it.valueFieldIds,
                                        dicObj,
                                      )}
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                        self: 2,
                                      }}
                                      fieldNames={{
                                        label: 'nameZh',
                                        value: 'dictValue',
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                    />
                                  </Box>
                                )}
                              {/*时间的第一个选择*/}
                              {checkTypeStatus(it.valueFieldIds) &&
                                checkTypeStatusTwo(it.valueFieldIds) && (
                                  <Box
                                    width="109px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <SelectFieldCom
                                      label="条件"
                                      initLabel=""
                                      placeholder="请选择"
                                      name={'operationType-' + it.id}
                                      realName="operationType"
                                      queryType={queryType}
                                      setValue={setValue}
                                      getValues={getValues}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      nameMessage=""
                                      // defaultValue={it?.operationType}
                                      typeList={getDicList(
                                        it.valueFieldIds,
                                        dicObj,
                                      )}
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                        self: 3,
                                      }}
                                      fieldNames={{
                                        label: 'nameZh',
                                        value: 'dictValue',
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                    />
                                  </Box>
                                )}
                              {/*第二个输入框*/}
                              {!checkTypeStatusTwo(it.valueFieldIds) &&
                                !checkTypeStatusThree(it.valueFieldIds) &&
                                checkTypeStatus(it.valueFieldIds) &&
                                it.operation !== ISHAVEAVALUE &&
                                it.operation !== NOHAVEAVALUE && (
                                  <Box
                                    display="flex"
                                    alignItems="flex-end"
                                    position="relative"
                                    bottom={queryType !== 'detail' ? '-4px' : 0}
                                    width="220px"
                                  >
                                    <TextFieldCom
                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                      initLabel={false} //自定义的label是否显示
                                      showLabel={false} //是否需要显示label
                                      placeholder="请输入"
                                      queryType={queryType} //detail不可编辑用于详情
                                      helperText="" //用于校验的提醒文字
                                      name={`operationValue-${it.id}`}
                                      label="" //label
                                      control={control}
                                      errors={errors}
                                      setValue={setValue}
                                      isNumber={false}
                                      isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                                      isParseInt={false} //true 只能输入正整数，false可以输入小数
                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                      realName="operationValue"
                                      setFieldValue={setFieldValue}
                                      multiline={textIsMultiline}
                                      minRows={1}
                                      maxRows={1}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                      initHeight={{ height: 'auto' }}
                                    />
                                  </Box>
                                )}
                              {!checkTypeStatusTwo(it.valueFieldIds) &&
                                checkTypeStatusThree(it.valueFieldIds) &&
                                checkTypeStatus(it.valueFieldIds) &&
                                it.operation !== ISHAVEAVALUE &&
                                it.operation !== NOHAVEAVALUE && (
                                  <Box
                                    width="220px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <SelectFieldCom
                                      label="条件"
                                      initLabel=""
                                      placeholder="请选择"
                                      name={'operationValue-' + it.id}
                                      realName="operationValue"
                                      queryType={queryType}
                                      setValue={setValue}
                                      getValues={getValues}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      nameMessage=""
                                      multiple={selectIsMultiple}
                                      // defaultValue={it?.operationType}
                                      typeList={getFetchList(
                                        it.valueFieldIds,
                                        queryTagOperatorValue,
                                      )}
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                      fieldNames={{
                                        label: 'nameZh',
                                        value: 'labelCode',
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                    />
                                  </Box>
                                )}
                              {checkTypeStatusTwo(it.valueFieldIds) &&
                                it.operationType &&
                                it.operationType !== ISHAVEAVALUE &&
                                it.operationType !== NOHAVEAVALUE && (
                                  <Box
                                    width="109px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <SelectFieldCom
                                      label="日期的第二个条件"
                                      placeholder="请选择"
                                      initLabel=""
                                      name={'operation-' + it.id}
                                      queryType={queryType}
                                      setValue={setValue}
                                      getValues={getValues}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      nameMessage="日期的第二个条件"
                                      // defaultValue={it?.operation}
                                      typeList={getDicListTwo(
                                        it.operationType,
                                        dicObj,
                                      )}
                                      fieldNames={{
                                        label: 'nameZh',
                                        value: 'dictValue',
                                      }}
                                      realName="operation"
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                    />
                                  </Box>
                                )}
                              {checkTypeStatusTwo(it.valueFieldIds) &&
                                it.operationType === ISRELATIVE && (
                                  <Box
                                    // width="150px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <DatePickerCom
                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                      name={'operationValue-' + it.id}
                                      showLabel={false}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                      label=""
                                      defaultValue={
                                        it.operationValue ?? new Date()
                                      }
                                      queryType={queryType}
                                      setValue={setValue}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      realName="operationValue"
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                    />
                                  </Box>
                                )}
                              {/*相对时间的第一个输入框*/}
                              {checkTypeStatusTwo(it.valueFieldIds) &&
                                it.operationType === ISABSOLUTE && (
                                  <Box
                                    width="78px"
                                    display="flex"
                                    alignItems="flex-end"
                                    position="relative"
                                    bottom={queryType !== 'detail' ? '-4px' : 0}
                                  >
                                    <TextFieldCom
                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                      initLabel={false} //自定义的label是否显示
                                      showLabel={false} //是否需要显示label
                                      placeholder="请输入"
                                      queryType={queryType} //detail不可编辑用于详情
                                      helperText="" //用于校验的提醒文字
                                      name={`operationValue-${it.id}`}
                                      label="条件2数值" //label
                                      endAdornment="天"
                                      control={control}
                                      errors={errors}
                                      setValue={setValue}
                                      isNumber={true}
                                      isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                                      isParseInt={true} //true 只能输入正整数，false可以输入小数
                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                      initHeight={{ height: 'auto' }}
                                      realName="operationValue"
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                    />
                                  </Box>
                                )}
                              {/*相对时间的条件3*/}
                              {checkTypeStatusTwo(it.valueFieldIds) &&
                                it.operationType === ISABSOLUTE && (
                                  <Box
                                    width="109px"
                                    display="flex"
                                    alignItems="flex-end"
                                  >
                                    <SelectFieldCom
                                      label="条件3"
                                      placeholder="请选择"
                                      initLabel=""
                                      name={'operationAnd-' + it.id}
                                      queryType={queryType}
                                      setValue={setValue}
                                      getValues={getValues}
                                      control={control}
                                      errors={errors}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      nameMessage="条件2必选项"
                                      // defaultValue={it?.operationAnd}
                                      typeList={
                                        dicObj.PROFILE_RELATIVE_DATE_RANGE_OPERATOR
                                      }
                                      fieldNames={{
                                        label: 'nameZh',
                                        value: 'dictValue',
                                      }}
                                      realName="operationAnd"
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                        self: 4,
                                      }}
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                    />
                                  </Box>
                                )}
                              {checkTypeStatusTwo(it.valueFieldIds) &&
                                it.operationType === ISABSOLUTE &&
                                it.operationAnd &&
                                it.operationAnd !== ISBEFORE &&
                                it.operationAnd !== ISAFTER && (
                                  <Box
                                    width="78px"
                                    display="flex"
                                    alignItems="flex-end"
                                    position="relative"
                                    bottom={queryType !== 'detail' ? '-4px' : 0}
                                  >
                                    <TextFieldCom
                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                      initLabel={false} //自定义的label是否显示
                                      showLabel={false} //是否需要显示label
                                      placeholder="请输入"
                                      queryType={queryType} //detail不可编辑用于详情
                                      helperText="" //用于校验的提醒文字
                                      name={`operationAndValue-${it.id}`}
                                      label="条件4数值" //label
                                      endAdornment="天"
                                      control={control}
                                      errors={errors}
                                      setValue={setValue}
                                      isNumber={true}
                                      isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                                      isParseInt={true} //true 只能输入正整数，false可以输入小数
                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                      rules={{
                                        required: true, //是否是必填项true 必填 false 非必填
                                      }}
                                      initHeight={{ height: 'auto' }}
                                      realName="operationAndValue"
                                      setFieldValue={setFieldValue}
                                      parameter={{
                                        wid: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                        selfId: it.id,
                                      }}
                                    />
                                  </Box>
                                )}
                              {item.withinItem.length > 1 &&
                                queryType !== 'detail' && (
                                  <Box display="flex" alignItems="flex-end">
                                    <HighlightOffIcon
                                      sx={{
                                        width: '24px',
                                        height: '24px',
                                        marginLeft: '18px',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() =>
                                        handleAddRuleDetailDataDelete({
                                          wid: item.id,
                                          pid,
                                          type: cLabel === '满足',
                                          selfId: it.id,
                                        })
                                      }
                                    />
                                  </Box>
                                )}
                              {item.withinItem.length - 1 === ind &&
                                queryType !== 'detail' && (
                                  <Box
                                    sx={{
                                      width: '35px',
                                      height: '35px',
                                      padding: '10px',
                                      borderRadius: '50%',
                                      background: '#fafafa',
                                      boxShadow:
                                        '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                                      position: 'absolute',
                                      right: '12px',
                                      bottom: '15px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      handleAddRuleDetailData({
                                        id: item.id,
                                        pid,
                                        type: cLabel === '满足',
                                      })
                                    }
                                  >
                                    <AddIcon
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                      }}
                                    />
                                  </Box>
                                )}
                            </Box>
                          );
                        })}
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        width="60px"
                        justifyContent="center"
                      >
                        {queryType !== 'detail' && (
                          <HighlightOffIcon
                            sx={{
                              width: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleAddRuleDataDelete({
                                id: detailId,
                                type: cLabel === '满足',
                                selfId: item.id,
                              });
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })}
            {queryType !== 'detail' && showButton !== 'hidden' && (
              <Box pl={5}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{
                    width: '90px',
                    borderRadius: '24px',
                    height: '34px',
                    marginTop: '12px',
                  }}
                  onClick={() => {
                    handleAddRuleData({
                      id: detailId,
                      type: cLabel === '满足',
                    });
                  }}
                >
                  添加
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
